<script setup lang="ts">
import KpSelectField from '@/components/KpSelectField.vue';
import { TechnologieStromerzeugungCollection } from '@/models/TechnologieStromerzeugung';
import { onMounted, type Ref } from 'vue';
import { useI18n } from 'vue-i18n';

const value: Ref<any> = defineModel();

withDefaults(
    defineProps<{
        label?: string;
    }>(),
    { label: () => useI18n().t('technologiestromerzeugung') },
);

const coll = new TechnologieStromerzeugungCollection();

onMounted(() => {
    coll.query();
});
</script>
<template>
    <KpSelectField
        :label="label"
        v-model="value"
        :options="coll.getModels()"
        option-label="bezeichnung"
        option-value="id"
    ></KpSelectField>
</template>
